import { devProxyS3Url } from './dev-proxy-s3-url';

const SITE_ORIGIN = (
  import.meta.env.VITE_PUBLIC_SITE_URL || 'https://lavka-cvetov.com'
).replace(/\/$/, '');

const STORAGE_ORIGIN = 'https://s3.regru.cloud/';

/**
 * Документ из S3 для открытия в новой вкладке — по нашему домену: nginx проксирует
 * /files/<bucket>/<key> в хранилище. В dev — через прокси Vite (как devProxyS3Url).
 */
export function storageFileUrl(url: string | null | undefined): string {
  if (url == null) return '';
  const s = String(url).trim();
  if (s === '') return '';
  if (!import.meta.env.PROD) return devProxyS3Url(s);
  return s.startsWith(STORAGE_ORIGIN) ? `${SITE_ORIGIN}/files/${s.slice(STORAGE_ORIGIN.length)}` : s;
}
